<!--suppress ALL -->
<div class="employee-overview-container">
  <p-tabView (onChange)="changeTab($event.index)" [activeIndex]="currentTabIndex" styleClass="netz-tabview">
    <p-tabPanel *ngIf="environmentService.standardTechnicianEnabled" [header]="'overview.all-tabs-data.tab-one.tab-title' | translate">
      <span *ngIf="!displayDetails">
        <div *ngIf="allTabsData.tabOne.data.length" class="overflow-tab-section">
          <div class="ui-inputgroup">
            <span class="ui-inputgroup-addon"><i class="pi pi-search search-icon"></i></span>
            <input (input)="tabOne.filterGlobal($event.target.value, 'contains')" pInputText placeholder="Search" size="25" type="text" />
          </div>
          <p-multiSelect
            (onChange)="tabOne.filter($event.value, 'permissions', 'custom')"
            [(ngModel)]="selectedPermissionFilters"
            [defaultLabel]="'Select'"
            [displaySelectedLabel]="false"
            [options]="allPermissions"
            [overlayVisible]="showOptionsPanel"
            class="filter-multiselect">
            <ng-template let-selectedFilters pTemplate="selectedItems">
              <ng-container *ngIf="!selectedFilters?.length">{{ 'app.drop_down.select' | translate }}</ng-container>
              <ng-container *ngIf="selectedFilters?.length">
                {{ selectedFilters.length }}
                {{ (selectedFilters.length > 1 ? 'overview.filter-text.multiple' : 'overview.filter-text.single') | translate }}
              </ng-container>
            </ng-template>
          </p-multiSelect>
        </div>

        <p-table
          #tabOne
          [filterDelay]="0"
          [globalFilterFields]="filterFields.tabOne"
          [hidden]="allTabsData.tabOne.data.length === 0"
          [value]="allTabsData.tabOne.data"
          autoLayout="true"
          styleClass="netz-table">
          <ng-template pTemplate="header">
            <tr *ngIf="allTabsData.tabOne.data.length">
              <th *ngFor="let col of allTabsData.tabOne.columns" [ngStyle]="{ width: col.width }" [pSortableColumn]="col.field">
                {{ 'overview.all-tabs-data.tab-one.columns.' + col.field | translate }}
                <p-sortIcon
                  [field]="col.field"
                  attr.ariaLabel="{{ 'table-header.sort-icon-label' | translate }}"
                  attr.ariaLabelAsc="{{ 'table-header.sort-icon-asc-label' | translate }}"
                  attr.ariaLabelDesc="{{ 'table-header.sort-icon-desc-label' | translate }}"></p-sortIcon>
              </th>
              <th class="actions-column"></th>
            </tr>
          </ng-template>
          <ng-template let-rowData let-rowIndex="rowIndex" pTemplate="body">
            <tr *ngIf="allTabsData.tabOne.data.length">
              <ng-container *ngFor="let col of allTabsData.tabOne.columns; let index = index">
                <td [ngStyle]="{ width: col.width }">
                  <div *ngIf="['viewDetails', 'permissions'].indexOf(col.field) === -1">
                    {{ parseTableValues(col.field, rowData[col.field]) }}
                  </div>
                  <div *ngIf="col.field === 'permissions' && rowData[col.field].length">
                    <span *ngFor="let item of rowData[col.field]">
                      {{ 'overview.details-data.data-rows.' + item | translate }}
                      <br />
                    </span>
                  </div>
                  <div *ngIf="col.field === 'permissions' && rowData[col.field].length === 0">
                    {{ '-' }}
                  </div>
                </td>
              </ng-container>

              <td class="actions-column">
                <div class="icons-container">
                  <div>
                    <span (click)="confirmDelete(rowData['companyId'])" class="pointer-cursor">
                      <i class="pi pi-trash" tabindex="0" appEnterClick></i>
                    </span>
                    <span (click)="sendMessage(rowData['companyId'])" class="pointer-cursor">
                      <i class="pi pi-envelope" tabindex="0" appEnterClick></i>
                    </span>
                  </div>
                  <div>
                    <span (click)="showDetails(rowIndex, rowData['companyId'])" class="pointer-cursor">
                      <i class="pi pi-eye" tabindex="0" appEnterClick></i>
                    </span>
                    <span
                      *ngIf="allowActiveTechnicianEdit"
                      (click)="showDetails(rowIndex, rowData['companyId'], true)"
                      class="pointer-cursor">
                      <i class="pi pi-pencil"></i>
                    </span>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr *ngIf="allTabsData?.tabOne?.columns">
              <td [attr.colspan]="allTabsData.tabOne.columns.length">
                {{ 'overview.no-data-available' | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>

        <div *ngIf="!isLoading && !allTabsData.tabOne.data.length" class="no-data-available">
          {{ 'overview.no-data-available' | translate }}
        </div>
      </span>

      <span *ngIf="displayDetails && currentTabIndex === 0">
        <app-details-form
          (postApplicationUpdate)="changeTab($event.index)"
          [detailsData]="detailsData"
          (clickBackButton)="closeDetails()"></app-details-form>
      </span>
    </p-tabPanel>

    <p-tabPanel
      [header]="'overview.all-tabs-data.tab-two.tab-title' | translate"
      [headerStyle]="environmentService.employeeOverviewHasWhiteTabBackground ? { 'background-color': '#ffffff' } : null">
      <span *ngIf="!displayDetails">
        <div *ngIf="allTabsData.tabTwo.data.length" class="overflow-tab-section">
          <div class="ui-inputgroup">
            <span class="ui-inputgroup-addon"><i class="pi pi-search search-icon"></i></span>
            <input (input)="tabTwo.filterGlobal($event.target.value, 'contains')" pInputText placeholder="Search" size="25" type="text" />
          </div>
          <p-multiSelect
            (onChange)="tabTwo.filter($event.value, 'permissions', 'custom')"
            [defaultLabel]="'Select'"
            [displaySelectedLabel]="false"
            [options]="allPermissions"
            class="filter-multiselect">
            <ng-template let-selectedFilters pTemplate="selectedItems">
              <ng-container *ngIf="!selectedFilters?.length">{{ 'app.drop_down.select' | translate }}</ng-container>
              <ng-container *ngIf="selectedFilters?.length">
                {{ selectedFilters.length }}
                {{ (selectedFilters.length > 1 ? 'overview.filter-text.multiple' : 'overview.filter-text.single') | translate }}
              </ng-container>
            </ng-template>
          </p-multiSelect>
        </div>

        <p-table
          #tabTwo
          [filterDelay]="0"
          [globalFilterFields]="filterFields.tabTwo"
          [hidden]="allTabsData.tabTwo.data.length === 0"
          [value]="allTabsData.tabTwo.data"
          autoLayout="true"
          styleClass="netz-table">
          <ng-template pTemplate="header">
            <tr *ngIf="allTabsData.tabTwo.data.length">
              <th *ngFor="let col of allTabsData.tabTwo.columns" [ngStyle]="{ width: col.width }" [pSortableColumn]="col.field">
                {{ 'overview.all-tabs-data.tab-two.columns.' + col.field | translate }}
                <p-sortIcon
                  [field]="col.field"
                  attr.ariaLabel="{{ 'table-header.sort-icon-label' | translate }}"
                  attr.ariaLabelAsc="{{ 'table-header.sort-icon-asc-label' | translate }}"
                  attr.ariaLabelDesc="{{ 'table-header.sort-icon-desc-label' | translate }}"></p-sortIcon>
              </th>
              <th class="actions-column"></th>
            </tr>
          </ng-template>
          <ng-template let-rowData let-rowIndex="rowIndex" pTemplate="body">
            <tr *ngIf="allTabsData.tabTwo.data.length">
              <ng-container *ngFor="let col of allTabsData.tabTwo.columns; let index = index">
                <td [ngStyle]="{ width: col.width }">
                  <div *ngIf="['viewDetails', 'permissions'].indexOf(col.field) === -1">
                    {{ parseTableValues(col.field, rowData[col.field]) }}
                  </div>
                  <div *ngIf="col.field === 'permissions' && rowData[col.field].length">
                    <span *ngFor="let item of rowData[col.field]">
                      {{ 'overview.details-data.data-rows.' + item | translate }}
                      <br />
                    </span>
                  </div>
                  <div *ngIf="col.field === 'permissions' && rowData[col.field].length === 0">
                    {{ '-' }}
                  </div>
                </td>
              </ng-container>

              <td class="actions-column">
                <div class="icons-container">
                  <div>
                    <span (click)="confirmDelete(rowData['companyId'])" class="pointer-cursor">
                      <i class="pi pi-trash"></i>
                    </span>
                    <span (click)="sendMessage(rowData['companyId'])" class="pointer-cursor">
                      <i class="pi pi-envelope"></i>
                    </span>
                  </div>
                  <div>
                    <span (click)="showDetails(rowIndex, rowData['companyId'])" class="pointer-cursor">
                      <i class="pi pi-eye"></i>
                    </span>
                    <!-- <span (click)="showDetails(rowIndex, rowData['companyId'], true)" class="pointer-cursor">
                      <i class="pi pi-pencil"></i>
                    </span> -->
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr *ngIf="allTabsData?.tabTwo?.columns">
              <td [attr.colspan]="allTabsData.tabTwo.columns.length">
                {{ 'overview.no-data-available' | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>

        <div *ngIf="!isLoading && !allTabsData.tabTwo.data.length" class="no-data-available">
          {{ 'overview.no-data-available' | translate }}
        </div>
      </span>

      <span *ngIf="displayDetails && currentTabIndex === 1">
        <app-details-form
          (postApplicationUpdate)="changeTab($event.index)"
          [detailsData]="detailsData"
          (clickBackButton)="closeDetails()"></app-details-form>
      </span>
    </p-tabPanel>

    <p-tabPanel
      *ngIf="environmentService.dataForConcessionValidationScenario !== 'Mixed' || environmentService.showConcessionDistrictHeating"
      [header]="'overview.all-tabs-data.tab-three.tab-title' | translate"
      [headerStyle]="environmentService.employeeOverviewHasWhiteTabBackground ? { 'background-color': '#ffffff' } : null">
      <span *ngIf="!displayDetails">
        <div *ngIf="allTabsData.tabThree.data.length" class="overflow-tab-section">
          <div class="ui-inputgroup">
            <span class="ui-inputgroup-addon"><i class="pi pi-search search-icon"></i></span>
            <input (input)="tabThree.filterGlobal($event.target.value, 'contains')" pInputText placeholder="Search" size="25" type="text" />
          </div>
          <p-multiSelect
            (onChange)="tabThree.filter($event.value, 'permissions', 'custom')"
            [defaultLabel]="'Select'"
            [displaySelectedLabel]="false"
            [options]="allPermissions"
            class="filter-multiselect">
            <ng-template let-selectedFilters pTemplate="selectedItems">
              <ng-container *ngIf="!selectedFilters?.length">
                {{ 'overview.all-tabs-data.filter-by-permissions-placeholder' | translate }}
              </ng-container>
              <ng-container *ngIf="selectedFilters?.length">
                {{ selectedFilters.length }}
                {{ (selectedFilters.length > 1 ? 'overview.filter-text.multiple' : 'overview.filter-text.single') | translate }}
              </ng-container>
            </ng-template>
          </p-multiSelect>

          <p-multiSelect
            (onChange)="tabThree.filter($event.value, 'status', 'custom_equal_not_combined')"
            [defaultLabel]="'Select'"
            [displaySelectedLabel]="false"
            [options]="this.allTabsData?.tabThree?.filterOptions?.status"
            class="filter-multiselect">
            <ng-template let-selectedFilters pTemplate="selectedItems">
              <ng-container *ngIf="!selectedFilters?.length">
                {{ 'overview.all-tabs-data.filter-by-status-placeholder' | translate }}
              </ng-container>
              <ng-container *ngIf="selectedFilters?.length">
                {{ selectedFilters.length }}
                {{ (selectedFilters.length > 1 ? 'overview.filter-text.multiple' : 'overview.filter-text.single') | translate }}
              </ng-container>
            </ng-template>
          </p-multiSelect>
        </div>

        <p-table
          #tabThree
          [filterDelay]="0"
          [globalFilterFields]="filterFields.tabThree"
          [hidden]="allTabsData.tabThree.data.length === 0"
          [value]="allTabsData.tabThree.data"
          autoLayout="true"
          styleClass="netz-table">
          <ng-template pTemplate="header">
            <tr *ngIf="allTabsData.tabThree.data.length">
              <th
                *ngFor="let col of allTabsData.tabThree.columns; let index = index"
                [ngStyle]="{ width: col.width }"
                [pSortableColumnDisabled]="col.field === 'applicationProcess'"
                [pSortableColumn]="col.field">
                {{ 'overview.all-tabs-data.tab-three.columns.' + col.field | translate }}
                <p-sortIcon
                  *ngIf="col.field !== 'applicationProcess'"
                  [field]="col.field"
                  attr.ariaLabel="{{ 'table-header.sort-icon-label' | translate }}"
                  attr.ariaLabelAsc="{{ 'table-header.sort-icon-asc-label' | translate }}"
                  attr.ariaLabelDesc="{{ 'table-header.sort-icon-desc-label' | translate }}"></p-sortIcon>
              </th>
              <th class="actions-column"></th>
            </tr>
          </ng-template>
          <ng-template let-rowData let-rowIndex="rowIndex" pTemplate="body">
            <tr *ngIf="allTabsData.tabThree.data.length">
              <ng-container *ngFor="let col of allTabsData.tabThree.columns; let index = index">
                <td [ngStyle]="{ width: col.width }">
                  <div *ngIf="['applicationProcess', 'permissions', 'status'].indexOf(col.field) === -1">
                    {{ parseTableValues(col.field, rowData[col.field]) }}
                  </div>
                  <div *ngIf="col.field === 'permissions' && rowData[col.field].length">
                    <span *ngFor="let item of rowData[col.field]">
                      {{ 'overview.details-data.data-rows.' + item | translate }}
                      <br />
                    </span>
                  </div>
                  <div *ngIf="col.field === 'permissions' && rowData[col.field].length === 0">
                    {{ '-' }}
                  </div>
                  <div *ngIf="col.field === 'status'">
                    <span>
                      {{ 'overview.details-data.data-rows.' + rowData[col.field]?.toLowerCase() | translate }}
                    </span>
                  </div>
                </td>
              </ng-container>

              <td class="actions-column">
                <span (click)="showDetails(rowIndex, rowData['technicianId'])" class="pointer-cursor">
                  <i class="pi pi-eye"></i>
                </span>
                <span
                  *ngIf="rowData.status?.toLowerCase() !== 'expired'"
                  (click)="showDetails(rowIndex, rowData['technicianId'], true)"
                  class="pointer-cursor">
                  <i class="pi pi-pencil"></i>
                </span>
                <span (click)="sendMessage(rowData['technicianId'])" *ngIf="!rowData['applicationProcess']" class="pointer-cursor">
                  <i class="pi pi-envelope"></i>
                </span>
                <span
                  (click)="updateProcessingStatus(rowData)"
                  *ngIf="role === 'administrator' || role === 'employee'"
                  class="pointer-cursor">
                  <i
                    [ngClass]="rowData.locked === '0' ? 'pi pi-unlock unlock-icon-style' : 'pi pi-lock lock-icon-style'"
                    pTooltip="{{ 'overview.jurisdiction-overview.processing-status' | translate }}"></i>
                </span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr *ngIf="allTabsData?.tabThree?.columns">
              <td [attr.colspan]="allTabsData.tabThree.columns.length">
                {{ 'overview.no-data-available' | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>

        <div *ngIf="!isLoading && !allTabsData.tabThree.data.length" class="no-data-available">
          {{ 'overview.no-data-available' | translate }}
        </div>
      </span>

      <span *ngIf="displayDetails && currentTabIndex === 2">
        <app-details-form
          (postApplicationUpdate)="changeTab($event.index)"
          [detailsData]="detailsData"
          (clickBackButton)="closeDetails()"></app-details-form>
      </span>
    </p-tabPanel>

    <p-tabPanel
      [header]="'overview.all-tabs-data.tab-four.tab-title' | translate"
      [headerStyle]="environmentService.employeeOverviewHasWhiteTabBackground ? { 'background-color': '#ffffff' } : null">
      <span *ngIf="!displayDetails">
        <div *ngIf="allTabsData.tabFour.data.length" class="overflow-tab-section">
          <div class="ui-inputgroup">
            <span class="ui-inputgroup-addon"><i class="pi pi-search search-icon"></i></span>
            <input (input)="tabFour.filterGlobal($event.target.value, 'contains')" pInputText placeholder="Search" size="25" type="text" />
          </div>
          <p-multiSelect
            (onChange)="tabFour.filter($event.value, 'permissions', 'custom')"
            [(ngModel)]="selectedPermissionFilters"
            [defaultLabel]="'Select'"
            [displaySelectedLabel]="false"
            [options]="allPermissions"
            [overlayVisible]="showOptionsPanel"
            class="filter-multiselect">
            <ng-template let-selectedFilters pTemplate="selectedItems">
              <ng-container *ngIf="!selectedFilters?.length">{{ 'app.drop_down.select' | translate }}</ng-container>
              <ng-container *ngIf="selectedFilters?.length">
                {{ selectedFilters.length }}
                {{ (selectedFilters.length > 1 ? 'overview.filter-text.multiple' : 'overview.filter-text.single') | translate }}
              </ng-container>
            </ng-template>
          </p-multiSelect>
        </div>

        <p-table
          #tabFour
          [filterDelay]="0"
          [globalFilterFields]="filterFields.tabFour"
          [hidden]="allTabsData.tabFour.data.length === 0"
          [value]="allTabsData.tabFour.data"
          autoLayout="true"
          styleClass="netz-table">
          <ng-template pTemplate="header">
            <tr *ngIf="allTabsData.tabFour.data.length">
              <th *ngFor="let col of allTabsData.tabFour.columns" [ngStyle]="{ width: col.width }" [pSortableColumn]="col.field">
                {{ 'overview.all-tabs-data.tab-four.columns.' + col.field | translate }}
                <p-sortIcon
                  [field]="col.field"
                  attr.ariaLabel="{{ 'table-header.sort-icon-label' | translate }}"
                  attr.ariaLabelAsc="{{ 'table-header.sort-icon-asc-label' | translate }}"
                  attr.ariaLabelDesc="{{ 'table-header.sort-icon-desc-label' | translate }}"></p-sortIcon>
              </th>
              <th class="actions-column"></th>
            </tr>
          </ng-template>
          <ng-template let-rowData let-rowIndex="rowIndex" pTemplate="body">
            <tr *ngIf="allTabsData.tabFour.data.length">
              <ng-container *ngFor="let col of allTabsData.tabFour.columns; let index = index">
                <td [ngStyle]="{ width: col.width }">
                  <div *ngIf="['viewDetails', 'permissions'].indexOf(col.field) === -1">
                    {{ parseTableValues(col.field, rowData[col.field]) }}
                  </div>
                  <div *ngIf="col.field === 'permissions' && rowData[col.field].length">
                    <span *ngFor="let item of rowData[col.field]">
                      {{ 'overview.details-data.data-rows.' + item | translate }}
                      <br />
                    </span>
                  </div>
                  <div *ngIf="col.field === 'permissions' && rowData[col.field].length === 0">
                    {{ '-' }}
                  </div>
                </td>
              </ng-container>

              <td class="actions-column">
                <div class="icons-container">
                  <div>
                    <span (click)="updateProcessingStatus(rowData)" class="pointer-cursor">
                      <i class="{{ rowData.locked === '0' ? 'pi pi-unlock unlock-icon-style' : 'pi pi-lock lock-icon-style' }}"></i>
                    </span>
                    <span (click)="confirmDelete(rowData['technicianId'])" class="pointer-cursor">
                      <i class="pi pi-trash"></i>
                    </span>
                    <span (click)="sendMessage(rowData['technicianId'])" class="pointer-cursor">
                      <i class="pi pi-envelope"></i>
                    </span>
                  </div>
                  <div>
                    <span (click)="showDetails(rowIndex, rowData['technicianId'])" class="pointer-cursor">
                      <i class="pi pi-eye"></i>
                    </span>
                    <span (click)="showDetails(rowIndex, rowData['technicianId'], true)" class="pointer-cursor">
                      <i class="pi pi-pencil"></i>
                    </span>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr *ngIf="allTabsData?.tabFour?.columns">
              <td [attr.colspan]="allTabsData.tabFour.columns.length">
                {{ 'overview.no-data-available' | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>

        <div *ngIf="!isLoading && !allTabsData.tabFour.data.length" class="no-data-available">
          {{ 'overview.no-data-available' | translate }}
        </div>
      </span>

      <span *ngIf="displayDetails && currentTabIndex === 3">
        <app-details-form
          (postApplicationUpdate)="changeTab($event.index)"
          [detailsData]="detailsData"
          (clickBackButton)="closeDetails()"></app-details-form>
      </span>
    </p-tabPanel>

    <p-tabPanel *ngIf="showRegisteredChimneySweepersTab" [header]="'overview.all-tabs-data.tab-five.tab-title' | translate">
      <span *ngIf="!displayDetails">
        <div *ngIf="allTabsData.tabFive.data.length" class="overflow-tab-section">
          <div class="ui-inputgroup">
            <span class="ui-inputgroup-addon"><i class="pi pi-search search-icon"></i></span>
            <input (input)="tabFive.filterGlobal($event.target.value, 'contains')" pInputText placeholder="Search" size="25" type="text" />
          </div>
          <p-multiSelect
            (onChange)="tabFive.filter($event.value, 'permissions', 'custom')"
            [defaultLabel]="'Select'"
            [displaySelectedLabel]="false"
            [options]="allPermissions"
            class="filter-multiselect">
            <ng-template let-selectedFilters pTemplate="selectedItems">
              <ng-container *ngIf="!selectedFilters?.length">{{ 'app.drop_down.select' | translate }}</ng-container>
              <ng-container *ngIf="selectedFilters?.length">
                {{ selectedFilters.length }}
                {{ (selectedFilters.length > 1 ? 'overview.filter-text.multiple' : 'overview.filter-text.single') | translate }}
              </ng-container>
            </ng-template>
          </p-multiSelect>
        </div>

        <p-table
          #tabFive
          [filterDelay]="0"
          [globalFilterFields]="filterFields.tabFive"
          [hidden]="allTabsData.tabFive.data.length === 0"
          [value]="allTabsData.tabFive.data"
          autoLayout="true"
          styleClass="netz-table">
          <ng-template pTemplate="header">
            <tr *ngIf="allTabsData.tabFive.data.length">
              <th
                *ngFor="let col of allTabsData.tabFive.columns; let index = index"
                [ngStyle]="{ width: col.width }"
                [pSortableColumnDisabled]="col.field === 'applicationProcess'"
                [pSortableColumn]="col.field">
                {{ 'overview.all-tabs-data.tab-five.columns.' + col.field | translate }}
                <p-sortIcon
                  *ngIf="col.field !== 'applicationProcess'"
                  [field]="col.field"
                  attr.ariaLabel="{{ 'table-header.sort-icon-label' | translate }}"
                  attr.ariaLabelAsc="{{ 'table-header.sort-icon-asc-label' | translate }}"
                  attr.ariaLabelDesc="{{ 'table-header.sort-icon-desc-label' | translate }}"></p-sortIcon>
              </th>
              <th class="actions-column" *ngIf="!(!environmentService.showRegisteredChimneySweepersIcons && role !== 'administrator')"></th>
            </tr>
          </ng-template>
          <ng-template let-rowData let-rowIndex="rowIndex" pTemplate="body">
            <tr *ngIf="allTabsData.tabFive.data.length">
              <ng-container *ngFor="let col of allTabsData.tabFive.columns; let index = index">
                <td [ngStyle]="{ width: col.width }">
                  <div *ngIf="['applicationProcess', 'permissions'].indexOf(col.field) === -1">
                    {{ parseTableValues(col.field, rowData[col.field]) }}
                  </div>
                  <div *ngIf="col.field === 'permissions' && rowData[col.field].length">
                    <span *ngFor="let item of rowData[col.field]">
                      {{ 'overview.details-data.data-rows.' + item | translate }}
                      <br />
                    </span>
                  </div>
                  <div *ngIf="col.field === 'permissions' && rowData[col.field].length === 0">
                    {{ '-' }}
                  </div>
                  <button
                    (click)="showDetails(rowIndex, rowData['technicianId'], true)"
                    *ngIf="col.field === 'applicationProcess'"
                    [disabled]="evaluateDetailsButtonState(rowData, col.field)"
                    class="execute-btn-width"
                    id="application-view-button-{{ index }}"
                    label="{{ 'execute-button-label' | translate }}"
                    pButton
                    type="button"></button>
                </td>
              </ng-container>

              <td class="actions-column" *ngIf="!(!environmentService.showRegisteredChimneySweepersIcons && role !== 'administrator')">
                <span (click)="sendMessage(rowData['companyId'])" *ngIf="!rowData['applicationProcess']" class="pointer-cursor">
                  <i class="pi pi-envelope"></i>
                </span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr *ngIf="allTabsData?.tabFive?.columns">
              <td [attr.colspan]="allTabsData.tabFive.columns.length">
                {{ 'overview.no-data-available' | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>

        <div *ngIf="!isLoading && !allTabsData.tabFive.data.length" class="no-data-available">
          {{ 'overview.no-data-available' | translate }}
        </div>
      </span>

      <span *ngIf="displayDetails && currentTabIndex === 4">
        <app-details-form
          (postApplicationUpdate)="changeTab($event.index)"
          [detailsData]="detailsData"
          (clickBackButton)="closeDetails()"></app-details-form>
      </span>
    </p-tabPanel>
  </p-tabView>
</div>

<p-confirmDialog
  #deleteConfirmDialog
  icon="pi pi-info-circle"
  message="{{ 'messages.delete-confirmation-message' | translate }}"
  styleClass="netz-confirm-dialog">
  <p-footer>
    <button (click)="deleteConfirmDialog.accept()" label="{{ 'yes-button-label' | translate }}" pButton type="button"></button>
    <button (click)="deleteConfirmDialog.reject()" label="{{ 'no-button-label' | translate }}" pButton type="button"></button>
  </p-footer>
</p-confirmDialog>

<p-confirmDialog key="applicationEditConfirmDialog" icon="pi pi-info-circle" styleClass="netz-confirm-dialog"></p-confirmDialog>

<app-loader *ngIf="isLoading"></app-loader>
